import React from "react";
import PhoneInput from "react-phone-input-2";
import { Input, Spacer } from '@nextui-org/react';
import "react-phone-input-2/lib/style.css";

const DriversAndDocuments = ({
  setDriversAndDocumentsToState,
  driver1,
  driver2,
  truck,
  bol,
  po,
  stopType,
  driverPhone
}) => {
  const inputStyles = {
    css: { 
      $$inputBorderRadius: "0.375rem", 
      flexGrow: 1, 
      h: 40, 
      mt: 2,
      backgroundColor: "white",
      "&:hover": {
        borderColor: "hsl(var(--p))"
      }
    },
    shadow: false,
    bordered: true,
    rounded: true,
    classNames: {
      input: "text-sm",
      label: "text-sm font-medium text-gray-700"
    }
  };

  const labelStyles = "text-sm font-medium text-gray-700 mb-1";
  const gridStyles = "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 p-4 bg-base-100 rounded-lg shadow-sm";

  const renderInput = (label, type, placeholder, value, field) => (
    <div className="form-control w-full">
      <label className={labelStyles}>{label}</label>
      <Input
        type={type}
        placeholder={placeholder}
        clearable
        onChange={(e) => setDriversAndDocumentsToState("driverAndDocuments", field, e.target.value)}
        value={value}
        {...inputStyles}
      />
    </div>
  );

  const renderPhoneInput = () => (
    <div className="form-control w-full">
      <label className={labelStyles}>Driver Phone (for Auto-Linking)</label>
      <div className="mt-2">
        <PhoneInput
          country={"us"}
          prefix={'+'}
          containerClass="w-full"
          inputClass="w-full h-10 rounded-lg border border-gray-300 focus:border-primary focus:ring-1 focus:ring-primary"
          buttonClass="border-gray-300"
          dropdownClass="border-gray-300"
          preferredCountries={["us", "in"]}
          value={driverPhone}
          onChange={phone => setDriversAndDocumentsToState('driverAndDocuments', 'driverPhone', phone)}
        />
      </div>
    </div>
  );

  const renderFirstRow = () => (
    <div className={gridStyles}>
      {renderInput("Driver 1", "text", "Enter Driver 1 Employee Code", driver1, "driver1")}
      {renderInput("Truck No.", "text", "Enter Truck Number", truck, "truck")}
      {renderInput("BOL", "text", "Enter BOL Number", bol, "bol")}
      {renderInput("PO", "text", "Enter Purchase Order Number", po, "po")}
    </div>
  );

  const renderSecondRow = () => (
    <div className={gridStyles}>
      {renderInput("Driver 2", "text", "Enter Driver 2 Employee Code", driver2, "driver2")}
      {renderInput("Stop Type", "text", "Enter Stop Type (Pickup/Drop)", stopType, "stopType")}
      <div className="col-span-1 md:col-span-2">
        {renderPhoneInput()}
      </div>
    </div>
  );

  return (
    <div className="space-y-4 p-4 bg-base-200 rounded-xl">
      {renderFirstRow()}
      {renderSecondRow()}
    </div>
  );
};

export default DriversAndDocuments;